<div class="aems-bread-crumb m-b-16"><a routerLink="/master-data">Master Data</a><span> / </span><a routerLink="/master-data/part-exclusion">Part Code Exclusion</a><span> / {{ editMode() ? 'Edit' : 'Add New' }}</span></div>
<h3 class="m-b-16">{{ editMode() ? 'Edit Part Exclusion Rule' : 'Add Part Exclusion Rule' }}</h3>
<form [formGroup]="form">
  <div class="aems-card">
    <div class="pure-g">
      <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        @if (editMode()) {
          <mc-input ngDefaultControl label="Mode" formControlName="repairMode" [disabled]="true" fit="small" required></mc-input>
        } @else {
          <mc-select ngDefaultControl label="Mode" formControlName="repairMode" required (optionselected)="onModeSelected($event)">
            @for (mode of modes; track mode) { <mc-option [value]="mode">{{ mode }}</mc-option> }
          </mc-select>
        }
      </div>
      <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        @if (editMode()) {
          <mc-input ngDefaultControl label="Part Number" formControlName="partNumber" [disabled]="true" fit="small" required></mc-input>
        } @else {
          <mc-input
            ngDefaultControl
            label="Part Number"
            formControlName="partNumber"
            placeholder="Enter part number"
            fit="small"
            required
            (blur)="onPartNumberChange($event)"
            (keyup.enter)="onPartNumberChange($event)">
          </mc-input>
        }
      </div>
      <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-input ngDefaultControl label="Description" formControlName="description" [disabled]="true" fit="small"></mc-input>
      </div>
    </div>
    <div class="exclusive-part-row m-b-12">
      <mc-input ngDefaultControl class="exclusive-part-input" label="Exclusive part number" placeholder="Enter part number" fit="small" formControlName="exclusivePartNumberInput" (keyup.enter)="addExclusivePartNumber()"></mc-input>
      <mc-button fit="small" variant="outlined" appearance="neutral" (click)="addExclusivePartNumber()" (keydown.enter)="addExclusivePartNumber()" (keydown.space)="$event.preventDefault(); addExclusivePartNumber()">Add</mc-button>
    </div>
    <div class="exclusive-parts-table">
      <div class="exclusive-parts-header">Part Number</div>
      @if (exclusivePartNumbers().length === 0) {
        <div class="exclusive-parts-empty">No exclusive part numbers added.</div>
      } @else {
        @for (partNumber of exclusivePartNumbers(); track partNumber) {
          <div class="exclusive-part-item">
            <span>{{ partNumber }}</span>
            <mc-button fit="small" variant="plain" appearance="neutral" hiddenlabel icon="trash" padding="compact" (click)="removeExclusivePartNumber(partNumber)" (keydown.enter)="removeExclusivePartNumber(partNumber)" (keydown.space)="$event.preventDefault(); removeExclusivePartNumber(partNumber)">Remove {{ partNumber }}</mc-button>
          </div>
        }
      }
    </div>
  </div>
  <div class="right m-t-16">
    @if (editMode()) { <mc-button appearance="neutral" variant="outlined" icon="trash" (click)="deleting.set(true)" (keydown.enter)="deleting.set(true)" (keydown.space)="$event.preventDefault(); deleting.set(true)">Delete Rule</mc-button> }
    <mc-button appearance="neutral" variant="outlined" class="m-l-8" (click)="cancel()" (keydown.enter)="cancel()" (keydown.space)="$event.preventDefault(); cancel()">Cancel</mc-button>
    <mc-button appearance="primary" class="m-l-8" [loading]="submitting()" (click)="save()" (keydown.enter)="save()" (keydown.space)="$event.preventDefault(); save()">{{ editMode() ? 'Save changes' : 'Add exclusion' }}</mc-button>
  </div>
</form>
<mc-modal heading="Delete Rule" fit="small" dimension="small" [open]="deleting()" (closed)="deleting.set(false)">
  <p>Are you sure you want to delete this part exclusion rule?</p>
  <mc-button slot="secondaryAction" appearance="neutral" variant="outlined" (click)="deleting.set(false)" (keydown.enter)="deleting.set(false)" (keydown.space)="$event.preventDefault(); deleting.set(false)">Cancel</mc-button>
  <mc-button slot="primaryAction" appearance="primary" (click)="delete()" (keydown.enter)="delete()" (keydown.space)="$event.preventDefault(); delete()">Delete Rule</mc-button>
</mc-modal>
